import * as Globals from "../../globals";
import {MeasurementPreview} from "./manualMeasurementPreview";
import {MeasurementPointer} from "./MeasurementPointer";
import {WorkingMeasurement} from "./workingManualMeasurement";
import {toggleModeButtons, tmpGroup} from "../../main";
import {cursorTarget, setCursor} from "../../utils/utils";
import {clearGroup} from "../../sceneManager";

let preview = null;
let pointer = null;

export function startMeasurementPreview() {
    setCursor(Globals.cursors.none, cursorTarget.layoutView);
    pointer = new MeasurementPointer();
}

export function adjustPointer() {
    pointer.adjustPreview();
}

export function measurementClick() {
    pointer.onMeasurementClick();
    //Generate measurement between two selected objects
    if (! pointer.secondSelectedObj) {
        return;
    }
    preview = new MeasurementPreview(
        pointer.firstSelectedObj,
        pointer.secondSelectedObj,
        pointer.firstPosition,
        pointer.secondPosition
    );
    generateMeasurement(); 
    pointer.resetPointers();
}

function generateMeasurement() {
    clearGroup(tmpGroup);
    preview.createFirstMeasurement();
    preview.createSecondMeasurement();

    new WorkingMeasurement(
        preview.firstMeasurement,
        preview.secondMeasurement,
        preview.pos1,
        preview.pos2,
        preview.sel1Orientation,
        preview.sel2Orientation,
        preview.group
    );

    preview = null;
    toggleModeButtons();
}
